module.exports = __webpack_public_path__ + "img/V8.ec8450ef.png";